<template>
  <img
    v-if="resolvedSrc"
    :src="resolvedSrc"
  />
</template>

<script setup>
  import { ref, watch, toRef, inject } from "vue";
  import { useSignaturesStore } from "@/stores/signaturesStore";

  const props = defineProps({
    signature: {
      type: Object,
      default: null
    }
  });

  const resolvedSrc = ref(null);
  const signaturesStore = useSignaturesStore();
  const signaturesNetworkFallback = inject("signaturesNetworkFallback", false);

  const resolve = async (sig) => {
    if (!sig) {
      resolvedSrc.value = null;
      return;
    }
    // Backward compat: inline signatureData
    if (sig.signatureData) {
      resolvedSrc.value = sig.signatureData;
      return;
    }
    // New: signature ref
    if (sig.isSignatureRef && sig.id) {
      try {
        const result = await signaturesStore.getSignatureById(sig.id, {
          networkFallback: signaturesNetworkFallback
        });
        resolvedSrc.value = result?.data?.data ?? null;
      } catch {
        resolvedSrc.value = null;
      }
      return;
    }
    resolvedSrc.value = null;
  };

  watch(toRef(props, "signature"), resolve, { immediate: true, deep: true });
</script>
